<template>
  <div>
    <base-template>
    <section v-if="loading">
      <loading />
    </section>
    <section v-else-if="aceiteTermo">
      <div class="container pt-4 pb-5">
        <div class="mt-4">
          <h4 class="h4 color-blue font-weight-bold">
            Aceite do Termo de Associado
          </h4>
          <p class="mb-3">
            Leia o termo a seguir e confirme se estiver de acordo.
          </p>
          <Aceite
            :voltar="voltar"
            :action-aceite="true"
            @click="confirmarAceite()"
            :link-voltar="linkVoltar"
            :file="file"
            :termo="termo"
            :aceite="aceite"
          />
        </div>
      </div>
    </section>
    <section v-else class="main">
      <div class="container pt-5">
        <div class="row">
          <div
            class="alert alert-warning border-0 d-flex align-items-center justify-content-between position-relative"
            role="alert"
            v-if="exibirAvisoAtualizacaoContatos && !avisoAtualizacaoContatosFechado"
          >
            <i class="material-icons pr-2" style="font-size: 3em">info</i>
            <p class="message">
              Seus dados de contato não são atualizados há mais de 90 dias.
              Por favor, acesse seu perfil e revise seus contatos.
            </p>
            <router-link
              :to="{ name: 'meuperfil' }"
              type="button"
              class="btn btn-warning sepia mt-2 fit-content ml-2"
            >
              Revisar meus dados
            </router-link>
            <button
              type="button"
              class="close"
              @click="avisoAtualizacaoContatosFechado = true"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="row">
          <h3 class="pl-3">Meus Serviços</h3>
        </div>

        <div class="row pt-5">
          <div class="col-md-7 mb-2">
            <Slides />
          </div>
          <div class="col-md-5 col-12 d-md-block">
            <div class="card shadow-sm weather border-0 overflow-hidden">
              <div
                class="card-body p-0 d-flex -align-items-center justify-content-center"
              >
                <WeatherWidget />
              </div>
            </div>
          </div>
        </div>
        <ProdutosLista />
      </div>
    </section>
    </base-template>
    <BeneficioFuneralModal
      v-if="exibirAvisoAssistenciaFuneral"
      @close="fecharAvisoAssistenciaFuneral"
      @activate="ativarAssistenciaFuneral"
    />
  </div>
</template>
<script>
import ProdutosLista from "@/components/ProdutosLista.vue";
import BaseTemplate from "@/views/Dashboard/Dashboard.vue";
import WeatherWidget from "@/components/WeatherWidget.vue";
import Slides from "@/components/Slides.vue";
import Aceite from "@/components/aceite/Aceite.vue";
import BeneficioFuneralModal from "@/components/BeneficioFuneralModal.vue";
import { obterDocumentoAssociado } from "@/utils/assistenciaFuneral";
import axios from "axios";
export default {
  name: "Home",
  components: {
    ProdutosLista,
    BaseTemplate,
    WeatherWidget,
    Slides,
    Aceite,
    BeneficioFuneralModal,
  },
  data() {
    return {
      loading: false,
      aceiteTermo: false,
      voltar: true,
      linkVoltar: "#",
      linkAceite: "#",
      aceite: "Eu concordo com o termo acima",
      termo: null,
      file: null,
      exibirAvisoAssistenciaFuneral: false,
      exibirAvisoAtualizacaoContatos: false,
      avisoAtualizacaoContatosFechado: false,
    };
  },
  created() {
    this.consultarAtualizacaoContatos();
    this.configurarAvisoAssistenciaFuneral();
    // const dadosUsuario = this.$store.getters.getUsuario;
    // if (dadosUsuario.carteira === "undefined" && !dadosUsuario.termoAssinado) {
    //   this.loading = true;
    //   this.$http
    //     .get("/api/Drive/BuscarTermoAssociado")
    //     .then((response) => {
    //       this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
    //       this.aceiteTermo = true;
    //       this.loading = false;
    //     })
    //     .catch((error) => {
    //       this.aceiteTermo = false;
    //       this.loading = false;
    //       console.log(error);
    //     });
    // } else {
    //   this.loading = false;
    // }
  },
  methods: {
    async consultarAtualizacaoContatos() {
      const dadosUsuario = this.$store.getters.getUsuario || {};

      // Preserva o status conhecido caso a consulta esteja indisponível.
      const dadosSessao = this.$user || {};
      this.exibirAvisoAtualizacaoContatos =
        typeof dadosUsuario.atualizacaoCadastral === "boolean"
          ? dadosUsuario.atualizacaoCadastral
          : dadosSessao.atualizacaoCadastral === true;

      try {
        const response = await this.$http.get(
          "/api/CdlBh/StatusAtualizacaoContatos"
        );
        const dados = response.data || {};
        const status =
          typeof dados.atualizacaoCadastral === "boolean"
            ? dados.atualizacaoCadastral
            : dados.AtualizacaoCadastral;
        if (typeof status !== "boolean") {
          throw new Error("Status de atualização dos contatos não retornado.");
        }
        this.exibirAvisoAtualizacaoContatos = status;
        if (process.env.NODE_ENV === "development") {
          console.info("[Home] StatusAtualizacaoContatos:", {
            atualizacaoCadastral: status,
            exibirAviso: this.exibirAvisoAtualizacaoContatos,
          });
        }
      } catch (error) {
        console.warn(
          "Não foi possível consultar a atualização dos contatos.",
          error
        );
      }
    },
    async configurarAvisoAssistenciaFuneral() {
      const dadosUsuario = this.$store.getters.getUsuario;
      const chaveAbertura = "exibirAssistenciaFuneralAposLogin";
      const chaveVerificacao = "assistenciaFuneralModalVerificado";
      const abriuSessaoAgora = sessionStorage.getItem(chaveAbertura) === "true";
      const jaVerificouNestaSessao =
        sessionStorage.getItem(chaveVerificacao) === "true";

      // O gatilho de login pode desaparecer durante um hot reload ou uma
      // atualização da SPA. A chave de verificação garante que a Home faça a
      // consulta ao menos uma vez por sessão sem repetir ao trocar de tela.
      if (!abriuSessaoAgora && jaVerificouNestaSessao) return;

      sessionStorage.setItem(chaveVerificacao, "true");
      sessionStorage.removeItem(chaveAbertura);

      if (dadosUsuario.carteira) return;

      const documento = this.obterDocumentoAssociado(dadosUsuario);
      if (!documento) {
        // Não deixa uma inconsistência nos dados da sessão bloquear a campanha.
        // O CPF/CNPJ continuará sendo obrigatório ao entrar na jornada de ativação.
        this.exibirAvisoAssistenciaFuneral = true;
        console.warn(
          "CPF/CNPJ do associado não encontrado para verificar a Assistência Funeral Zelo."
        );
        return;
      }

      try {
        const login = await axios.post(
          `${this.obterBaseUrlAgil()}/v1/autenticacao/login`,
          {
            email: process.env.VUE_APP_CDL_AGIL_EMAIL,
            senha: process.env.VUE_APP_CDL_AGIL_SENHA,
          }
        );
        const corpoLogin = (login && login.data) || {};
        const token =
          (corpoLogin.resultado && corpoLogin.resultado.token) ||
          corpoLogin.token;
        if (!token) throw new Error("Token do CDL Ágil não retornado.");

        const response = await axios.get(
          `${this.obterBaseUrlAgil()}/v1/integracoes/arta/assistencia-funeral?documento=${encodeURIComponent(
            documento
          )}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const envelope = (response && response.data) || {};
        const resultado =
          envelope.resultado ||
          envelope.Resultado ||
          envelope.data ||
          envelope.Data ||
          envelope;
        const beneficiarios =
          resultado.beneficiariosAtivos || resultado.BeneficiariosAtivos;
        const ativos = Array.isArray(beneficiarios) ? beneficiarios : [];

        this.exibirAvisoAssistenciaFuneral = ativos.length === 0;
      } catch (error) {
        this.exibirAvisoAssistenciaFuneral = true;
        console.warn(
          "Não foi possível confirmar a situação da Assistência Funeral Zelo.",
          error
        );
      }
    },
    obterBaseUrlAgil() {
      return (process.env.VUE_APP_CDL_AGIL_URL || "").replace(/\/$/, "");
    },
    obterDocumentoAssociado(dadosUsuario) {
      return obterDocumentoAssociado(dadosUsuario);
    },
    fecharAvisoAssistenciaFuneral() {
      this.exibirAvisoAssistenciaFuneral = false;
    },
    ativarAssistenciaFuneral() {
      this.fecharAvisoAssistenciaFuneral();
      this.$router.push({
        name: "assistenciafuneral",
        query: { acao: "ativar" },
      });
    },
    async confirmarAceite() {
      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      this.aceiteTermo = false;

      this.$http
        .post(`/api/Drive/AceitarTermoAssociado`, {
          dtVersao: new Date(),
          dtAceite: new Date(),
          ipOrigem: sessionStorage.ip,
          browserData: navigator.appVersion,
        })
        .then((response) => {
          if (response.statusCode === 200) {
            this.$store.dispatch("getUserData");
            this.$user.termoAssinado = true;
            this.aceiteTermo = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$toast.open({
            message: "Falha ao assinar o termo.",
            type: "error",
          });
        });
    },
  },
};

(function (f, b, g) {
    // var a = {
    //     key: 'yT3Npv0d',
    //     customer: {
    //     name: '',
    //     email: '',
    //     phone: ''
    //   }      
    // };
    var e;
    var c = f.getElementsByTagName(b)[0];
    if (f.getElementById(g)) { return };
    e = f.createElement(b);
    e.id = g;
    e.src = 'https://app.track.co/widget.min.js';
    e.type = 'text/javascript';
    e.async = true;
    e.onload = e.onreadystatechange = function () {
    var h = this.readyState;
    if (h && h !== 'complete' && h !== 'loaded') { return };
      // try {
      // var c = new TrackWidget();
      // c.createWidget(a);
      // } catch (i) {
      //   console.log();
      //  }
    };
    c.parentNode.insertBefore(e, c);
}(document, 'script', 'trackwidget-js')) ; 

// var a = {
//   key: "afaTBHHU",
//     onCreate: () => {
//       TrackWidget.showWidget(false);
//     }
// };
</script>
<style lang="scss" scoped>
.weather {
  /* background: url("../../assets/img/bg.svg"); */
  /* background-position: center; */
  background-color: white;
  min-height: calc(100% - 40px);
  background-size: cover;
  background-repeat: no-repeat;
}
.card {
  transition: all 0.2s;
  &:hover {
    transform: translateY(-10px);
  }
}
.alert-warning {
  width: 100%;
}
@media screen and (max-width: 900px) {
  .alert-warning {
    flex-direction: column;
    margin: 1rem;
  }
  .close {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}

.sepia {
  color: white !important;
  background: #856404 !important;
  border: 1px solid #856404 !important;
}
</style>
